import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueCookies from 'vue-cookies';

import { store } from '@/stores/Store'
import Home from '@/pages/home/Home.vue'
import User from '@/pages/user/Index.vue'
import AssociationRegister from '@/pages/associationregister/Index.vue'
import Activity from '@/pages/activity/Index.vue'
import ContributionPeriods from '@/pages/setting/ContributionPeriods.vue'
import Logs from '@/pages/setting/Logs.vue'
import ConfirmUser from '@/pages/confirmUser/Index.vue'
import Setting from '@/pages/setting/Index.vue'
import ApplicationSettings from '@/pages/setting/ApplicationSettings.vue'
import Themes from '@/pages/setting/Themes.vue'
import Person from '@/pages/person/Index.vue'
import Groups from "@/pages/groups/Index.vue"
import ChangePassword from '@/pages/changePassword/Index.vue'

import Association from "@/pages/association/association.vue"
import AssociationAdmin from "@/pages/association/association-admin-home.vue"
import AssociationGroups from "@/pages/association/association-admin-groups.vue"
import AssociationReport from "@/pages/association/association-admin-report.vue"

import Occasion from "@/pages/association/association-occasions.vue"


Vue.config.productionTip = false

// Importing the helpers
import interceptorsSetup from "@/helpers/functions/Interceptors";
import refreshAuthorizationTokenFromSession from './helpers/functions/AxiosToken';
import { TabService } from "@/services/TabService"
import { SnackbarService } from './services/SnackbarService';

require('dotenv').config();

const routes: RouteConfig[] = [
    {
        path: '/',
        component: Home,
    },
    {
        path: '/user',
        component: User,
    },
    {
        path: '/associationregister',
        component: AssociationRegister
    },
    {
        path: '/confirmUser',
        component: ConfirmUser
    },
    {
        path: '/changePassword',
        component: ChangePassword
    },
    {
        path: '/person',
        component: Person
    },
    {
        path: '/association/',
        component: Association, children: [
            {
                path: "",
                component: AssociationAdmin
            },
            {
                path: "report",
                component: AssociationReport
            },
            {
                path: "groups",
                component: Groups
            },
            //{
            //    path: "activities",
            //    component: Activity
            //}, 
            {
                path: "persons",
                component: Person
            },            
            {
                path: "occasions",
                component: Occasion,
                children: [
                    {
                        path: "occasion",
                        beforeEnter: (to: Route, from: Route, next) => {
                            TabService.hideTabs();
                            next();
                        }
                    }
                ]
            }
        ],
        beforeEnter: (to: Route, from: Route, next) => {
            TabService.showTabs();
            next();
        }
    },
    {
        path: '/activity',
        component: Activity
    },
    {
        path: '/setting/', component: Setting, children: [
            {
                path: "",
                component: ApplicationSettings
            },
            {
                path: "periods",
                component: ContributionPeriods,
                children: [
                    {
                        path: "period",
                        beforeEnter: (to: Route, from: Route, next) => {
                            TabService.hideTabs();
                            next();
                        }
                    }
                ]
            },
            {
                path: "logs",
                component: Logs
            },
            {
                path: 'themes',
                component: Themes
            }
        ],
        beforeEnter: (to: Route, from: Route, next) => {
            TabService.showTabs();
            next();
        }
    },

]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
    // 4. Provide the history implementation to use. We are using the hash history for simplicity here.
    // router v4: history: VueRouter.createWebHashHistory(),
    routes, // short for `routes: routes`

})

router.afterEach((to, from) => {
    SnackbarService.resetMessages();
})

Vue.use(VueCookies);

interceptorsSetup(store, router, Vue.$cookies);

new Vue({
    router: router,
    store: store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
